import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9445c35e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading users...", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "no-users"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No users available", -1))
const _hoisted_8 = [
  _hoisted_7
]

import type { fetchedUser } from "~/types/fetchedUser"
import { ref, computed, onBeforeMount, nextTick } from 'vue'
import { getAllUsers } from '@/composables/userComposables'
import DefaultProfileImageDisplayer from '@/components/reusable/defaultProfileImageDisplayer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'userPicker',
  props: {
    showArrow: { type: Boolean },
    position: {},
    width: {},
    excludeUsers: {}
  },
  emits: ["userSelected", "cancelled"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const usersContainer = ref<HTMLElement | null>(null)
const users = ref<fetchedUser[]>([])
const isLoadingUsers = ref<boolean>(false)

// Create a computed property which maps each fetchedUser to a UserPickerUser
const mappedUsers = computed(() => {
    return users.value
        .filter(user => !props.excludeUsers?.includes(user.id))
        .map(user => ({
            id: user.id,
            emailAddress: user.emailAddress || '',
            profileImage: user.profileImage || '',
            userName: user.userName || ''
        }))
})

function selectUser(user: fetchedUser) {
    emits('userSelected', user)
}

function handleBlur() {
    emits('cancelled')
}

onBeforeMount(() => {
    getAllUsers(users.value, isLoadingUsers)
    nextTick(() => {
        usersContainer.value?.focus()
    })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "usersContainer",
    ref: usersContainer,
    tabindex: "0",
    onBlur: handleBlur,
    class: _normalizeClass(["users-container", {
            'show-arrow': _ctx.showArrow !== false,
            [`position-${_ctx.position || 'bottom'}`]: true
        }]),
    style: _normalizeStyle({ width: _ctx.width || '22rem' })
  }, [
    (isLoadingUsers.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(mappedUsers.value, (user) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (selectUser(user)),
            key: user.id,
            class: "user"
          }, [
            (user.profileImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: user.profileImage,
                  referrerpolicy: "no-referrer",
                  class: "rounded-image-mini"
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createBlock(DefaultProfileImageDisplayer, {
                  key: 1,
                  width: "2.4rem",
                  firstCharacter: user.userName?.charAt(0) || 'U'
                }, null, 8, ["firstCharacter"])),
            _createElementVNode("p", null, _toDisplayString(user.userName), 1)
          ], 8, _hoisted_4))
        }), 128)),
    (!isLoadingUsers.value && mappedUsers.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true)
  ], 38))
}
}

})